import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import getRootReducer from '../reducers';
import initSagas from '../utils/initSagas';

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
// eslint-disable-next-line no-console
const onError = (error) => console.log('Uncaught Global Saga Error:', error);
const sagaMiddleware = createSagaMiddleware(onError);
const middlewares = [sagaMiddleware, thunk];
const middlewareEnhancer = applyMiddleware(...middlewares);
const enhancers = [middlewareEnhancer];
const composedEnhancers = composeEnhancers(...enhancers);

const configureAppStore = (initState) => {
  const store = createStore(
    getRootReducer(),
    initState,
    composedEnhancers,
  );
  initSagas(sagaMiddleware);
  return store;
};

let storeInstance = null;

export const getStore = () => {
  if (!storeInstance) {
    storeInstance = configureAppStore({});
  }
  return storeInstance;
};
